import React from 'react';

const DonatePage = () => (
  <div className="max-w-4xl mx-auto px-4 py-10 text-center">
    <h1 className="text-3xl font-bold text-orange-600 mb-4">Support JanShakti</h1>
    <p className="mb-4 text-gray-700">
      JanShakti is a citizen-driven initiative to empower democracy. Your donations help us stay online and reach more voters.
    </p>
    <div className="bg-white shadow-md rounded-xl p-6 inline-block">
      <p className="font-medium text-gray-800">Scan the UPI QR Code or use the UPI ID:</p>
      <p className="text-green-700 font-bold mt-2">jan-shakti@upi</p>
      <img src="/assets/qr-code-placeholder.png" alt="UPI QR Code" className="w-48 h-48 mx-auto mt-4" />
      <p className="text-sm text-gray-600 mt-2">Every ₹1 helps power this platform for India</p>
    </div>
  </div>
);

export default DonatePage;
